import { render, staticRenderFns } from "./RelatedProductCardPDP.vue?vue&type=template&id=7c2184aa&scoped=true&"
import script from "./RelatedProductCardPDP.vue?vue&type=script&lang=js&"
export * from "./RelatedProductCardPDP.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductCardPDP.vue?vue&type=style&index=0&id=7c2184aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2184aa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
